import { render, staticRenderFns } from "./prepare-collective.vue?vue&type=template&id=203fd8f8"
import script from "./prepare-collective.vue?vue&type=script&lang=js"
export * from "./prepare-collective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports